import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';

const DeepLinkObserver = () => {
  const history = useHistory();
  const listener = useRef<PluginListenerHandle | null>(null);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      if (listener.current) {
        listener.current?.remove?.();
        listener.current = null;
      }
      // Deep Links only work in cordova enabled environments such as Android or iOS -
      // to prevent errors we don't enable this feature on the web platform or testing
      // environments.
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        const url = new URL(event.url);
        let pathname = url.pathname.replace('record', 'shared');

        history.push(pathname);
      }).then((urlListener) => {
        listener.current = urlListener;
      });
      return () => {
        listener.current?.remove();
        listener.current = null;
      };
    }
    return () => {};
  }, [history]);

  return <></>;
};

export default DeepLinkObserver;
